import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { useLang } from "../context/LanguageContext";
import LanguageSwitcher from "./LanguageSwitcher";
import { TID } from "../constants/testIds";
import { Menu, X, ChevronDown } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_performing-arts-ch/artifacts/78ttazwv_400PngdpiLogoCropped.png";

const Header = () => {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  const [acadOpen, setAcadOpen] = useState(false);

  const link = ({ isActive }) =>
    `text-sm tracking-wide transition-colors ${isActive ? "text-primary" : "text-foreground/80 hover:text-primary"}`;

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-md bg-background/85 border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid={TID.navHome}>
          <img src={LOGO_URL} alt="KK Academy" className="h-12 w-auto" />
          <div className="leading-tight hidden sm:block">
            <div className="font-serif-display text-lg text-foreground">KK Academy</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">House of Dance & Music</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          <NavLink to="/" end className={link} data-testid={TID.navHome}>{t("nav.home")}</NavLink>
          <div
            className="relative"
            onMouseEnter={() => setAcadOpen(true)}
            onMouseLeave={() => setAcadOpen(false)}
          >
            <button className="text-sm tracking-wide text-foreground/80 hover:text-primary inline-flex items-center gap-1" data-testid={TID.navAcademy}>
              {t("nav.academy")} <ChevronDown className="w-3.5 h-3.5" />
            </button>
            {acadOpen && (
              <div className="absolute top-full left-0 pt-2 w-56">
                <div className="bg-card border border-border rounded-md shadow-xl overflow-hidden">
                  <NavLink to="/musikakademie" className="block px-4 py-3 text-sm hover:bg-secondary hover:text-primary" data-testid={TID.navMusic}>{t("nav.music")}</NavLink>
                  <NavLink to="/tanzakademie" className="block px-4 py-3 text-sm hover:bg-secondary hover:text-primary" data-testid={TID.navDance}>{t("nav.dance")}</NavLink>
                </div>
              </div>
            )}
          </div>
          <NavLink to="/workshops" className={link} data-testid={TID.navWorkshops}>{t("nav.workshops")}</NavLink>
          <NavLink to="/events" className={link} data-testid={TID.navEvents}>{t("nav.events")}</NavLink>
          <NavLink to="/lehrpersonen" className={link} data-testid={TID.navTeachers}>{t("nav.teachers")}</NavLink>
          <NavLink to="/galerie" className={link} data-testid={TID.navGallery}>{t("nav.gallery")}</NavLink>
          <NavLink to="/kontakt" className={link} data-testid={TID.navContact}>{t("nav.contact")}</NavLink>
        </nav>

        <div className="flex items-center gap-3">
          <LanguageSwitcher />
          <Link
            to="/anmeldung"
            className="hidden sm:inline-flex px-5 py-2 rounded-full text-sm font-medium btn-gold"
            data-testid={TID.navEnroll}
          >
            {t("nav.enroll")}
          </Link>
          <button
            className="lg:hidden text-foreground"
            onClick={() => setOpen(!open)}
            data-testid={TID.mobileMenuToggle}
            aria-label="Menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-background border-t border-border">
          <div className="px-4 py-4 flex flex-col gap-1">
            {[
              ["/", t("nav.home")],
              ["/musikakademie", t("nav.music")],
              ["/tanzakademie", t("nav.dance")],
              ["/workshops", t("nav.workshops")],
              ["/events", t("nav.events")],
              ["/lehrpersonen", t("nav.teachers")],
              ["/galerie", t("nav.gallery")],
              ["/kontakt", t("nav.contact")],
              ["/anmeldung", t("nav.enroll")],
            ].map(([to, label]) => (
              <NavLink
                key={to}
                to={to}
                end={to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `py-3 px-2 text-base border-b border-border ${isActive ? "text-primary" : "text-foreground/90"}`
                }
              >
                {label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
